<template>
<div class="image-container" :class="classes">
    <iframe
            v-if="video"
            width="100%"
            height="100%"
            :src="videoPath"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
    />
    <transition v-else name="fade">
        <img class="w-full h-full object-cover" :src="imageUrl" @load="onLoaded" v-show="loaded" :alt="alt">
    </transition>
</div>
</template>

<script>
export default {
  name: 'LazyImage',
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    video: String,
    classes: {
      type: Array
    },
    alt: {
      type: String
    },
  },
  data () {
    return {
      loaded: false,
    }
  },
  computed: {
    videoPath () {
      return this.video.toString().replace('/watch?v=', '/embed/')
    }
  },
  methods: {
    onLoaded () {
      this.loaded = true
    },
  },
  watch: {
    imageUrl: {
      handler (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loaded = false
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.fade-enter-active {
    transition: opacity .3s ease-out;
}

.fade-enter-to {
    opacity: 1;
}

.fade-enter {
    opacity: 0;
}

.image-container {
    background-color: #f5f5f5;
    width: 100%;
}

</style>
